<template>
  <Select :clearable="clearable===false?false:true" :multiple="multiple" :max-tag-count="1" :disabled="disabled" 
    @on-change="change" :placeholder="placeholder||'请选择'" v-model="currentValue" :transfer="transfer||false">
    <Option
      v-for="(item) in dicValues"
      :key="item.code"
      :label="item.txt"
      :value="item.code"
    ></Option>
  </Select>
</template>

<script>
export default {
  props: ["dicType", "value","disabled","multiple","placeholder","clearable","transfer"],
  components: {},
  data() {
    return {
      dic:{},
    };
  },
  watch: {},
  computed: {
    dicValues() {
      if (!this.dic || typeof this.dic[this.dicType] == "undefined") {
        return [{ txt: "", code: "" }];
      } else {
        const data = this.dic[this.dicType]
        const keys = Object.keys(data);
        const out = keys.map((code)=>{
          return {
            code:code,
            txt:data[code],
          }
        })
        return out;
      }
    },
    currentValue: {
      // 动态计算currentValue的值
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit("input", val);
      }
    }
  },
  created() {
    this.dic = JSON.parse(localStorage.dic);
  },
  methods: {
    change(val) {
      this.$emit('change',val)
    }
  }
};
</script>
<style lang="scss"></style>
